import React from "react";
import BankIcon from "../assets/icons/bank.svg"
import { renderHTML } from "../helpers";

export function BankDetailsCard({ bankDetails }) {
    return <div className="bdetail">
        <div className="left">
            <img src={BankIcon} alt="" />
        </div>
        <div className="right">
            <div className="bank-details" id="bank-details">
                {renderHTML(bankDetails)}
            </div>
        </div>
    </div>
}